// src/router/controleCambio.js
// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['triveni_governanca', 'financeiro']

// Registrado automaticamente pelo auto-glob em src/router/index.js

const controleCambioBreadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Controle de câmbio',
    to: 'ControleCambioList'
  }
]

export default [
  {
    path: '/controle-cambio',
    name: 'ControleCambioList',
    component: () => import('@/views/Financeiro/ControleCambio/ControleCambioListPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Controle de câmbio',
      breadcrumb: controleCambioBreadCrumb
    }
  }
]
